import DateFnsUtils from "@date-io/date-fns";
import { DialogActions, FormControl, Grid } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core/styles";
import { MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { mapActionsToProps } from "../../redux/cloudPBX/timeRing";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import { globalHistory } from "./../../history";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  bulletOffline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "red",
  },
  bulletOnline: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(1.8)",
    color: "chartreuse",
  },
});

class TimeRing extends Component {
  constructor(props) {
    super(props);
    this.state = {
      defaultValue: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalAction: false,
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
  }

  listCollumns = [
    { id: "name", numeric: true, disablePadding: false, label: "Tên cấu hình" },
    {
      id: "defaultValue",
      numeric: true,
      disablePadding: false,
      label: "Thời gian",
    },
    { id: "action", numeric: true, disablePadding: false, label: "Hành động" },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "from":
            case "to":
            case "status":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    createdAt: { gte: this.state.filters.where.gte },
                  });
                  where.and = and;
                } else {
                  and.push({
                    createdAt: { lte: this.state.filters.where.lte },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getConfigTime(filters.order, filters.pageSize, filters.page, {
      where,
    });
  }

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleView = (item) => {
    this.state.item = item;
    this.setState({ modalAction: !this.state.modalAction });
  };

  handleClose = () => {
    this.setState({ modalAction: false });
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleAction = () => {
    const { id, defaultValue } = this.state.item;
    this.props.configTime(id, defaultValue);
    setTimeout(
      function () {
        this.setState({ modalAction: false });
        this.props.getConfigTime();
      }.bind(this),
      500
    );
  };

  render() {
    const { classes, timeRing } = this.props;
    const { filters, item } = this.state;
    return (
      <React.Fragment>
        <TableData
          {...this.props}
          nameTable="Danh sách cấu hình cuộc gọi"
          items={timeRing}
          rowsPerPage={filters.pageSize}
          count={timeRing.length}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          handleEdit={this.handleView}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          allowEdit={true}
        />
        <Dialog
          open={this.state.modalAction}
          title={"Chỉnh sửa cấu hình"}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid container className={classes.grid}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Tên cấu hình"
                      variant="outlined"
                      className={classes.input}
                      value={this.state.item ? this.state.item.name : ""}
                      disabled
                      name="name"
                    />
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Thời gian (s)"
                      variant="outlined"
                      className={classes.input}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("defaultValue")
                            : null
                          : null
                      }
                      value={item ? (item.id ? item.defaultValue : null) : null}
                      name="defaultValue"
                      validators={["required", "isNumber", "minNumber: 0"]}
                      errorMessages={[
                        "Không được để trống",
                        "Sai định dạng thời gian",
                        "Sai định dạng thời gian",
                      ]}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
                <DialogActions>
                  <Button
                    onClick={this.handleClose}
                    color="secondary"
                    className={classes.button}>
                    Hủy
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}>
                    Lưu
                  </Button>
                </DialogActions>
              </FormControl>
            </ValidatorForm>
          }
          onClose={this.handleClose}
        />
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

TimeRing.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  timeRing: state.timeRing.times,
  loading: state.timeRing.loading,
});

TimeRing = connect(mapStateToProps, mapActionsToProps)(TimeRing);

export default withStyles(styles)(TimeRing);
